import React from 'react';
import { UrgencyBar } from '../components/landing/UrgencyBar';
import { HeroSection } from '../components/landing/HeroSection';
import { PainSection } from '../components/landing/PainSection';
import { ComparisonTable } from '../components/landing/ComparisonTable';
import { MechanismSection } from '../components/landing/MechanismSection';
import { SecretsSection } from '../components/landing/SecretsSection';
import { WarningSection } from '../components/landing/WarningSection';
import { ModulesSection } from '../components/landing/ModulesSection';
import { TestimonialsSection } from '../components/landing/TestimonialsSection';
import { PricingSection } from '../components/landing/PricingSection';
import { GuaranteeSection } from '../components/landing/GuaranteeSection';
import { FAQSection } from '../components/landing/FAQSection';
import { FinalCTASection } from '../components/landing/FinalCTASection';
import { DisclaimerSection } from '../components/landing/DisclaimerSection';
import { FooterSection } from '../components/landing/FooterSection';
export function LandingPage() {
  return <div className="min-h-screen font-body text-marron bg-white" data-id="element-316">
      <UrgencyBar data-id="element-317" />
      <HeroSection data-id="element-318" />
      <PainSection data-id="element-319" />
      <ComparisonTable data-id="element-320" />
      <MechanismSection data-id="element-321" />
      <SecretsSection data-id="element-322" />
      <WarningSection data-id="element-323" />
      <ModulesSection data-id="element-324" />
      <TestimonialsSection data-id="element-325" />
      <PricingSection data-id="element-326" />
      <GuaranteeSection data-id="element-327" />
      <FAQSection data-id="element-328" />
      <FinalCTASection data-id="element-329" />
      <DisclaimerSection data-id="element-330" />
      <FooterSection data-id="element-331" />
    </div>;
}